import { render, staticRenderFns } from "./EventDiscountForm.vue?vue&type=template&id=62d70a4d"
import script from "./EventDiscountForm.vue?vue&type=script&lang=js"
export * from "./EventDiscountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports